import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';

import { selectFeeTypes } from 'store/system/selectors/feeTypes.selectors';

const useFeeHistoryContext = () => {
  const feeTypes = useSelector(selectFeeTypes);

  const feeTypeNamesById = useMemo(() => _.mapValues(feeTypes, 'name'), [feeTypes]);

  return useMemo(() => ({ feeTypeNamesById }), [feeTypeNamesById]);
};

export default useFeeHistoryContext;
